import { SKYSCANNER_JHA } from '@web-platform/shared-universal-constants/src/jhaHeader';
import { getJhaToken } from '@web-platform/shared-universal-utils-frontend/src/helpers/getJhaToken/getJhaToken';

import type {
  Middleware,
  InitReq,
  RequestMetadata,
  RequestHandlerFunction,
} from '@skyscanner-internal/web-http-client-fetch';

export const jhaMiddleware: Middleware = {
  handle(
    req: InitReq,
    reqMetaData: RequestMetadata,
    next: RequestHandlerFunction,
  ): Promise<Response> {
    // Add JHA token to the request headers if available
    const jhaToken = getJhaToken();
    if (jhaToken) {
      const newHeaders = new Headers(req.headers);
      newHeaders.set(SKYSCANNER_JHA, jhaToken);
      req.headers = newHeaders;
    }

    return next(req, reqMetaData);
  },

  getName(): string {
    return 'JHAMiddleware';
  },
};
